import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b19366a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "t-test-detail basic" }
const _hoisted_2 = { class: "t-test-detail__content" }
const _hoisted_3 = { class: "d-flex flex-col md:flex-row" }
const _hoisted_4 = { class: "t-test-detail__content-image d-flex flex-col justify-content-center align-items-center mr-0 md:mr-20" }
const _hoisted_5 = { class: "d-flex flex-col w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-light-gray-gc mb-1" }, "Asesmen", -1))
const _hoisted_7 = { class: "text-3xl text-primary-gc font-semibold mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "animate-pulse"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-52 w-52 bg-gray-200 rounded-full" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "d-flex flex-col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-base text-light-gray-gc mb-1" }, "Kamu adalah", -1))
const _hoisted_14 = { class: "text-2xl text-primary-gc font-semibold mb-1" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "d-flex w-full" }
const _hoisted_17 = { class: "t-test-detail__content-wrapper d-flex flex-column" }
const _hoisted_18 = { class: "t-test-detail__content-detail d-flex flex-column mt-4" }
const _hoisted_19 = { class: "t-test-detail__content-detail-wrapper d-flex" }
const _hoisted_20 = { class: "d-flex flex-column w-full" }
const _hoisted_21 = { class: "d-flex justify-between flex-col md:flex-row" }
const _hoisted_22 = { class: "text-xl font-semibold mb-4 md:mb-0" }
const _hoisted_23 = { class: "text-xl text-primary-gc font-medium" }
const _hoisted_24 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.detailTestResult.bundle.name), 1)
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "h-52 w-52 my-6",
                src: _ctx.detailTestResult.image
              }, null, 8, _hoisted_11)),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.detailTestResult.name), 1),
            _createElementVNode("div", {
              class: "text-sm text-justify",
              innerHTML: _ctx.detailTestResult.description
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_BButton, {
              variant: "warning",
              class: "text-center text-sm font-semibold mt-4 py-2 w-50 mr-4",
              onClick: _ctx.downloadResult
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Baca Laporan ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_BButton, {
              variant: "light",
              class: "text-center text-sm font-semibold mt-4 py-2 w-50",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('/home')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Tutup ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailTestResult.test_results, (data, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: idx,
                      class: "mb-5"
                    }, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("p", _hoisted_22, _toDisplayString(data.test_name), 1),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(data.name), 1)
                      ]),
                      (idx < _ctx.detailTestResult.test_results.length - 1)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_24))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}